import { Typography } from "@mui/material";
import { MprcLink } from "components";
import { AssessmentInstanceDto, AssessmentQuestionDto } from "generated/CoreApi_v1";
import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { UsersAnswerDrawer } from "views/assessment/player/common/UsersAnswerDrawer";

interface IProps {
    deployId?: string;
    viewData: AssessmentInstanceDto;
    question: AssessmentQuestionDto;
}

export const AssPlayerTotalAnswers: React.FC<IProps> = ({ viewData, question, deployId }) => {

    const { t } = useTranslation("assessment");

    const [dialog, setDialog] = useState<any>();

    ///
    const showQuestionAnswers = () => {
        setDialog(
            <UsersAnswerDrawer
                deployId={deployId!}
                instanceId={viewData.instanceId!}
                questionId={question.questionId}
                version={question.version}
                title={question.questionText}
                onClose={() => setDialog(null)}
            />
        );
    };

    ////////////////////////////////////////////////////////////////////////////
    /// RENDER
    ////////////////////////////////////////////////////////////////////////////

    return (
        <>
            {dialog}

            {
                viewData.surv?.identifyUsers == true
                    ?
                    <MprcLink onClick={() => viewData.surv?.identifyUsers ? showQuestionAnswers() : undefined}>
                        <Typography variant="caption" color="inherit">
                            {t("AssPlayer.Question.Revision.TotalAnswersText", { count: question.revision?.totalAnswers ?? 0 })}
                        </Typography>
                    </MprcLink>
                    :
                    <Typography variant="caption">
                        {t("AssPlayer.Question.Revision.TotalAnswersText", { count: question.revision?.totalAnswers ?? 0 })}
                    </Typography>
            }
        </>
    );
};
